import $ from 'jquery';
$(document).ready(function ($) {
    $('#js-sticky-box__close').click(function(){
        $('#js-sticky-box').addClass('uk-hidden');
    });
});